import { trackEvent } from "../../lib/analytics";

export const EVENT_ID = "racex-townsville-oct-2026";
export const money = (cents) => new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD", maximumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100);
export const eventDate = (date, compact = false) => new Date(`${date}T12:00:00+10:00`).toLocaleDateString("en-AU", { weekday: compact ? "short" : "long", day: "numeric", month: compact ? "short" : "long", year: "numeric", timeZone: "Australia/Brisbane" });
export const photo = (id) => `/api/media/racex-photo-${id}-v1.webp`;
export const PHOTOS = [
  { id: "51", alt: "EFS-liveried Camaro approaching the chequered line", label: "At the line" },
  { id: "25", alt: "Race-day guests smiling with their helmets in the pit area", label: "Better with good company" },
  { id: "29", alt: "White and black Adrenaline-liveried Camaro in the pit lane", label: "Ready to roll" },
  { id: "46", alt: "Yellow and blue Multispares race car on track", label: "Out on track" },
  { id: "28", alt: "RACEX team member and guests in the pit area", label: "Behind the scenes" },
  { id: "60", alt: "Red and white Gravely race car passing the pit area", label: "A different kind of Sunday" },
  { id: "02", alt: "Race-day guest wearing an EFS shirt beside the helmet racks", label: "Race-day moments" },
];

export function trackRacex(action, placement) {
  const name = `racex_${action}`;
  const data = { event_id: EVENT_ID, ...(placement ? { placement } : {}) };
  trackEvent(name, data);
  // Direct GA4 event delivery; the object push remains available for GTM diagnostics.
  const ga = process.env.REACT_APP_GA4_ID;
  if (ga && window.gtag) window.gtag("event", name, { ...data, send_to: ga });
}

export function captureAttribution() {
  const key = "nq-racex-attribution";
  const query = new URLSearchParams(window.location.search);
  const allowed = ["utm_source", "utm_medium", "utm_campaign", "utm_content"];
  const fresh = {};
  allowed.forEach((k) => {
    const value = query.get(k);
    if (value && value.length <= 100 && /^[A-Za-z0-9 _.-]+$/.test(value)) fresh[k] = value;
  });
  try {
    if (Object.keys(fresh).length) sessionStorage.setItem(key, JSON.stringify(fresh));
    const stored = JSON.parse(sessionStorage.getItem(key) || "{}");
    return Object.fromEntries(allowed.filter((k) => typeof stored[k] === "string" && stored[k].length <= 100 && /^[A-Za-z0-9 _.-]+$/.test(stored[k])).map((k) => [k, stored[k]]));
  } catch { return fresh; }
}